export enum CaseColumnKeys {
  CaseNumber = 'caseNumber',
  Priority = 'priority',
  RecordType = 'recordType',
  Type = 'taskType',
  Category = 'category',
  Subcategory = 'subcategory',
  DueDate = 'dueDate',
  Status = 'status',
  Subject = 'subject',
  Property = 'home',
  CaseOwner = 'caseOwner',
  CaseVendor = 'caseVendor',
  InStayGuestIssue = 'inStayGuestIssue',
  Recurring = 'recurringCaseSettingId',
  AirbnbTripIssue = 'isAirbnbTripIssue',
  HasExpense = 'hasExpense',
  CreateDate = 'createdAt',
  CreateTime = 'createTime',
  CreatedBy = 'createdByUserName',
  DueTime = 'dueTime',
  SpendThreshold = 'spendApprovalThreshold',
  MtMarkup = 'mtMarkupPercent',
  Age = 'age',
  AssignedFo = 'assignedFo',
  OpenCases = 'openCases',
  OriginalDueDate = 'originalDueDate',
  RevenueModel = 'revenueModel',
  OwnerNps = 'homeRating.ownerNps',
  GuestNps = 'homeRating.guestNps',
  GuestAirbnbRating = 'homeRating.guestAirbnbRating',
  GuestVrboRating = 'homeRating.guestVrboRating',
  PhotoCompletion = 'photoCompletion',
  AiGenerated = 'aiGenerated',
  GuestReadinessStatus = 'guestReadinessStatus',
  PhotoPercentage = 'stats.photosMeanPercentage',
  CheckListPercentage = 'stats.workMeanPercentage',
  Review = 'review',
  PropertyStatus = 'managedUnitAvailabilityStats',
  ValueAddedServices = 'valueAddedServices',
  Market = 'market',
  BookingRating = 'bookingRating',
  BookingNumber = 'booking.hash',
  CheckInDate = 'booking.checkInDate',
  CheckOutDate = 'booking.checkOutDate',
  GuestName = 'booking.guestName',
  NightsCount = 'booking.nightsCount',
  GuestsCount = 'booking.guestsCount',
  BookingSource = 'booking.source',
}
